import { getProjets } from '../../api/PROJETS/projets';
import { useQuery, keepPreviousData } from '@tanstack/react-query';

export const useProjets = (page, limit, search, filters = {}, tri = "date_debut", ordre = "DESC") => {
    return useQuery({
        queryKey: ['projets', page, limit, search, filters, tri, ordre],
        queryFn: () => getProjets(page, limit, search, filters, tri, ordre),
        placeholderData: keepPreviousData,
        staleTime: 2 * 60 * 1000,
        retry: false,
      });
};
